import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/GameModel';
import { GameLogic } from '../../Logic/GameLogic';
import { AnimationContents } from '../../../AnimationContents';
import { filters, Text, TextStyle } from 'pixi.js';
import { LocalizationContents } from '../../LocalizationContents';

export class UISpeedController extends AnimationBaseController {
    $model: GameModel;
    private shadow: Text;
    private speed: Text;
    private labelShadow: Text;
    private label: Text;
    private speedSegments: string = "";
    private distanceSegments: string = "";
    private frameCounter = 0;
    private maxFrames = 10;
    public constructor(
        @Inject private _options: any,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('UISpeedController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            modelWatch: {
                playerSpeed: (value: number) => {
                    // this.setTextByQuery('txt_speed', this._gameLogic.getPlayerSpeedInKilometers().toString());
                    // this.shadow.text = this._gameLogic.getPlayerSpeedInKilometers().toString();
                },
            }
        };
    }

    protected onInitialize(): void {
        //@ts-ignore
        // this.prepareBlur();
        this.setTextByQuery("title_distance", LocalizationContents.getText("title_distance"));
        this.setTextByQuery("tracker_distance", LocalizationContents.getText("tracker_distance"));
    }

    onUpdate() {
        this.frameCounter++;
        if (this.frameCounter > this.maxFrames) {
            const speed = Math.floor(this._gameLogic.getPlayerSpeedInKilometers()).toString();
            const distance = Math.floor(this.$model.playerDistance).toString();
            this.setTextByQuery('txt_speed', speed);
            this.setTextByQuery('txt_distance', distance);

            const speedSegments = speed.length;
            const distanceSegments = distance.length;
            if (speedSegments != this.speedSegments.length) {
                this.speedSegments = "";
                for (let i = 0; i < speedSegments; i++)
                    this.speedSegments += "8";
                this.setTextByQuery('txt_speed_segments', this.speedSegments);
            }
            if (distanceSegments != this.distanceSegments.length) {
                this.distanceSegments = "";
                for (let i = 0; i < distanceSegments; i++)
                    this.distanceSegments += "8";
                this.setTextByQuery('txt_distance_segments', this.distanceSegments);
            }
            this.frameCounter = 0;
        }

    }

    prepareBlur() {

        const blur = new filters.BlurFilter();
        blur.passes = 1;
        blur.resolution = 0.25;

        this.speed = this.getDisplayObjectByQuery('txt_speed')[0] as Text;
        this.label = this.getDisplayObjectByQuery('txt_label')[0] as Text;
        const style = new TextStyle(Object.assign(this.speed.style, { fill: "#D522D0" }));

        this.shadow = new Text("", style);
        this.labelShadow = new Text("speed", Object.assign(this.label.style, { fill: "#D522D0" }))
        this.shadow.anchor.set(0.5, 0.5);
        this.labelShadow.anchor.set(0.5, 0.5);
        this.labelShadow.position.set(0, this.label.y + this.label.height / 2);
        this.shadow.filters = [blur];
        this.labelShadow.filters = [blur];
        this.display.addChildAt(this.shadow, 0);
        this.display.addChildAt(this.labelShadow, 0);

    }

    protected onResize(width: number, height: number, scale: number) {
        // this.scaleX = this.scaleY = 1.5;


    }
}
